class ProductCardThumbnails extends HTMLElement {
  constructor() {
    super();
    this.mainImage = null;
    this.thumbnails = this.querySelectorAll('.product-card__thumbnail');
    this.interaction = this.dataset.interaction || 'click';
    this.preloadedImages = new Map();
  }

  connectedCallback() {
    this.mainImageWrapper = this.closest('.product-card')?.querySelector('.product-card__media a.media');

    if (!this.mainImageWrapper) return;

    this.mainImage = this.mainImageWrapper.querySelector('img');

    if (!this.mainImage) return;

    // Set first thumbnail as active by default
    if (this.thumbnails.length > 0) {
      this.thumbnails[0].classList.add('is-active');
    }

    this.thumbnails.forEach(thumbnail => {
      // Preload images
      this.preloadImage(thumbnail);

      const trigger = this.interaction === 'hover' ? 'mouseenter' : 'click';

      thumbnail.addEventListener(trigger, (e) => {
        if (this.interaction === 'click') e.preventDefault();

        // Update active class
        this.thumbnails.forEach(t => t.classList.remove('is-active'));
        thumbnail.classList.add('is-active');

        this.updateImage(thumbnail);
      });
    });
  }

  preloadImage(thumbnail) {
    const src = thumbnail.dataset.src;
    const srcset = thumbnail.dataset.srcset;
    if (!src) return;

    const img = new Image();
    img.src = src;
    if (srcset) img.srcset = srcset;
    this.preloadedImages.set(src, img);
  }

  updateImage(thumbnail) {
    const newSrc = thumbnail.dataset.src;
    const newSrcset = thumbnail.dataset.srcset;

    if (!newSrc || !this.mainImage) return;

    requestAnimationFrame(() => {
      this.mainImage.src = newSrc;
      if (newSrcset) this.mainImage.srcset = newSrcset;
    });
  }
}

customElements.define('product-card-thumbnails', ProductCardThumbnails);
